var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.finishLoading)?_c('ExpressOrderShowUser',{attrs:{"ex":_vm.ex}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }